import { User } from "../types/user";

export const clamp = (num: number, min: number, max: number) =>
  Math.min(Math.max(num, min), max);

export function isManager(user?: User): boolean {
  if (!user) return false;

  const hasManagerRoleInExtra = user.extra?.role
    ? user.extra.role.toLowerCase().includes("gestor") ||
      user.extra.role.toLowerCase().includes("manager") ||
      user.extra.role.toLowerCase().includes("admin")
    : false;

  const hasManagerRole =
    user.roles?.some(
      (role: string) =>
        role.toLowerCase().includes("gestor") ||
        role.toLowerCase().includes("manager") ||
        role.toLowerCase().includes("admin")
    ) ?? false;

  const hasManagerPermission =
    user.permissions?.some(
      (permission: string) =>
        permission.toLowerCase().includes("gestor") ||
        permission.toLowerCase().includes("manager") ||
        permission.toLowerCase().includes("admin")
    ) ?? false;

  return hasManagerRoleInExtra || hasManagerRole || hasManagerPermission;
}

/**
 * Gets the profile image URL with priority logic:
 * 1. Uploaded custom image (image.small.url) if fotoDePerfil is "custom"
 * 2. Avatar from extra.fotoDePerfil (if not "custom")
 * 3. Legacy image string format
 * 4. Fallback to undefined (component will use default avatar)
 */
export function getProfileImage(user?: User): string | undefined {
  if (!user) return undefined;

  // Priority 1: Check if user has uploaded a custom image
  if (user.extra?.fotoDePerfil === "custom") {
    // When fotoDePerfil is "custom", use the uploaded image from image.small.url
    if (typeof user.image === "object" && user.image?.small?.url) {
      const url = user.image.small.url;
      if (url.trim() !== "") {
        return url;
      }
    }
  }

  // Priority 2: Use avatar name from extra.fotoDePerfil (if not "custom")
  if (user.extra?.fotoDePerfil && user.extra.fotoDePerfil !== "custom") {
    return user.extra.fotoDePerfil;
  }

  // Priority 3: Check if user has uploaded image with valid URL (object format)
  if (typeof user.image === "object" && user.image?.small?.url) {
    const url = user.image.small.url;
    if (url.trim() !== "") {
      return url;
    }
  }

  // Priority 4: If image is a string (legacy format), return it
  if (typeof user.image === "string") {
    return user.image;
  }

  // Fallback: No image available
  return undefined;
}

export function FormatNumber(value: any) {
  try {
    if (isNaN(value)) return 0;
    return Intl.NumberFormat("pt-BR").format(Math.ceil(value));
  } catch (e) {
    return isNaN(value) ? 0 : value;
  }
}

export function abridgedControl(fullName: string, limit: number) {
  if (fullName.length > limit) {
    return toAbridged(fullName);
  }
  return fullName;
}

function toAbridged(fullName: string) {
  const token = ".";
  const separator = " ";
  const names = removePrepositions(fullName).split(separator);
  const firstName = names[0];
  let surnames = "";
  names
    .filter((name: any, index: any) => index)
    .map((name: string) => {
      return (surnames += `${separator}${name.charAt(0)}${token}`);
    });
  return `${firstName}${surnames.toUpperCase()}`;
}

function removePrepositions(fullName: string) {
  return fullName.replace(/ dos| das| dos| das| de| d'/gi, "");
}
